<app-switch-button
  [strictValueKey]="strictValueKey"
  [value]="value"
  (valueChange)="onValueChange($event)"
></app-switch-button>

<div class="row mt-1 mb-1">
  <p>{{ typeDescription | msg | async }}</p>
</div>
